import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch} from 'react-redux';
import { setLoading, storeInLocalStore } from 'store/reducers/mainSlice';
import { Dropdown } from 'react-bootstrap';
import Scroller from 'ui-component/Scroller';
import { FaPlus, FaSearch } from 'react-icons/fa';
import Filter from 'ui-component/filter-menu/Filter';
import { Skeleton } from '@mui/material';
import { TbDatabaseExclamation } from 'react-icons/tb';
import usePageTitle from 'hooks/usePageTitle';
import useIsMobile from 'utils/isMobileUtils';

// ✅ Clear
const ProductCategories = () => {
	const [setPageTitle] = usePageTitle('Categories');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);
	const history = useNavigate();
	const [listData, setListData] = useState([]);
	const [show, setShow] = useState('');
	const [isLoading, setIsloading] = useState(false);
	const [isInternalLoading, setIsInternalLoading] = useState(false);
	const dispatch = useDispatch();

	const [filters, setFilters] = useState([
		{
			label: 'Category',
			name: 'category',
			options: [
				{ label: 'iPhone', value: 'iphone' },
				{ label: 'iPad', value: 'ipad' },
				{ label: 'Cable', value: 'cable' },
				{ label: 'Charger', value: 'charger' }
			]
		}
	]);
	const [activeFilters, setActiveFilters] = useState({});

	useEffect(() => {
		getListData();
	}, []);

	const getListData = (internal = false) => {
		internal ? setIsInternalLoading(true) : setIsloading(true);
		api
			.getAllProductCategories()
			.then((res) => {
				setListData(res.data.data);
				dispatch(setLoading(false));
				internal ? setIsInternalLoading(false) : setIsloading(false);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const handleDelete = (id) => {
		api.deleteCategory(id).then((res) => {
			if (res.status) {
				setShow('');
				getListData();
				dispatch(storeInLocalStore({ stateAlertmessage: 'Category Deleted Successfully.' }));
			}
		});
	};

	const handleClose = () => setShow('');

	const isMobile = useIsMobile();

	return (
		<>
			<div className="row">
				{/* Area Chart */}
				<div className="col-xl-12 col-lg-12">
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<div
								style={{
									position: 'relative',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 8,
									minHeight: 38 // ensures enough height for the button
								}}
							>
								<button
									type="button"
									aria-label="Back"
									onClick={() => history(-1)}
									className="circle-back-btn"
									style={{
										position: 'absolute',
										left: 20,
										top: '50%',
										transform: 'translateY(-50%)'
									}}
								>
									{/* Replace with your fi arrow icon, example below */}
									<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
										<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</button>
								<h5
									style={{
										textAlign: 'center',
										flex: 1,
										margin: 0,
										display: 'flex',
										gap: 10,
										justifyContent: 'center',
										alignItems: 'center'
									}}
								>
									Categories
								</h5>
							</div>
							<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
								<Link to={'/settings/productcategories/create'} className="btn btn-primary btn-outlined-main white-var">
									<FaPlus /> Add New
								</Link>
							</div>
						</div>
					</div>
					<div className="section-head hide-on-mobile">
						<h2></h2>
						<div className="actions">
							<Link to={'/settings/productcategories/create'} className="btn btn-primary btn-outlined-main white-var">
								<FaPlus /> Add New
							</Link>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							gap: 10,
							paddingTop: 0,
							paddingBottom: 5,
							paddingLeft: 20,
							paddingRight: 20
						}}
						className="show-on-mobile"
					>
						<form className="form-inline navbar-search" style={{ flex: 1 }}>
							<div style={{ position: 'relative', width: '100%' }}>
								<input
									type="text"
									className="form-control bg-white border"
									placeholder="Search"
									aria-label="Search"
									aria-describedby="basic-addon2"
									style={{ width: '100%', paddingRight: 36 }}
								/>
								<span
									className="searchIcon"
									style={{
										position: 'absolute',
										right: 10,
										top: '50%',
										transform: 'translateY(-50%)',
										color: '#888',
										pointerEvents: 'none'
									}}
								>
									<FaSearch />
								</span>
							</div>
						</form>
						<div style={{ flexShrink: 0 }}>
							<Filter
								activeFilters={activeFilters}
								filters={filters}
							/>{' '}
						</div>
					</div>
					<div className={`card shadow-sm  bg-white mb-4  ${isMobile ? 'table-card shorter-table' : ''}`}>
						<div className=" align-items-center justify-content-between TableSerachBar">
							<div>
								<Filter
									activeFilters={activeFilters}
									filters={filters}
								/>
							</div>
							<form className="form-inline navbar-search">
								<div className="input-group">
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										// onChange={handleSearch}
									/>
									<span className="searchIcon">
										<FaSearch />
									</span>
								</div>
							</form>
						</div>
						{!isMobile ? (
							<div className="table-responsive-xl tableData UserListing p-2">
								<Scroller>
									<table className="table pm-table">
										<thead>
											<tr className="sticky-header">
												<th width="40%" scope="col">
													Category
												</th>
												<th width="12%" scope="col" className="text-center">
													Has Grades?
												</th>
												<th width="12%" scope="col" className="text-center">
													Has Storage?
												</th>
												<th width="12%" scope="col" className="text-center">
													Has Colors?
												</th>
												<th width="12%" scope="col" className="text-center">
													Allow Serials?
												</th>
												<th width="12%" scope="col" className="text-center">
													Action
												</th>
											</tr>
										</thead>
										<tbody>
											{isLoading ? (
												[...Array(5)].map((e, i) => (
													<tr>
														{[...Array(5)].map((e, i) => (
															<td>
																<Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
															</td>
														))}
													</tr>
												))
											) : (
												<>
													{listData?.map((row, index) => {
														return (
															<tr key={index}>
																<td className="align-middle">{row.name}</td>
																<td className="align-middle text-center">
																	{row?.has_grade_variations ? (
																		<span className="activeStatus bg-success">Yes</span>
																	) : (
																		<span className="inactiveStatus bg-danger">No</span>
																	)}
																</td>
																<td className="align-middle text-center">
																	{row?.has_storage_variations ? (
																		<span className="activeStatus bg-success">Yes</span>
																	) : (
																		<span className="inactiveStatus bg-danger">No</span>
																	)}
																</td>
																<td className="align-middle text-center">
																	{row?.has_color_variations ? (
																		<span className="activeStatus bg-success">Yes</span>
																	) : (
																		<span className="inactiveStatus bg-danger">No</span>
																	)}
																</td>
																<td className="align-middle text-center">
																	{row?.allow_serials ? (
																		<span className="activeStatus bg-success">Yes</span>
																	) : (
																		<span className="inactiveStatus bg-danger">No</span>
																	)}
																</td>
																<td className="align-middle text-center action-col">
																	<Dropdown className="btnDel iconbtn">
																		<Dropdown.Toggle as="span" id={`dropdown-toggle-${index}`}>
																			<i className="fas fa-ellipsis-h "></i>
																		</Dropdown.Toggle>
																		<Dropdown.Menu>
																			<Dropdown.Item
																				onClick={() => {
																					history(`/settings/productcategories/${row?.id}`);
																				}}
																			>
																				Edit
																			</Dropdown.Item>
																			<Dropdown.Item onClick={() => handleDelete(row?.id)}>Delete</Dropdown.Item>
																		</Dropdown.Menu>
																	</Dropdown>
																</td>
															</tr>
														);
													})}
													{listData?.length < 1 && (
														<tr className="no-hover">
															<td colSpan={5}>
																<div className="not-found-container">
																	<div className="not-found-icon">
																		<TbDatabaseExclamation />
																	</div>
																	<h6 className="not-found-text">No Data Available</h6>
																</div>
															</td>
														</tr>
													)}
												</>
											)}
										</tbody>
									</table>
								</Scroller>
							</div>
						) : (
							<div
								className="mobile-product-list"
								style={{ height: 'calc(100dvh - 300px)', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}
							>
								{isLoading ? (
									[...Array(8)].map((_, i) => (
										<div
											key={i}
											className="mobile-category-card skeleton"
											style={{
												borderRadius: 12,
												background: '#f5f5f5',
												padding: 16,
												minHeight: 60
											}}
										>
											<Skeleton variant="rounded" width={'100%'} height={30} />
										</div>
									))
								) : listData?.length > 0 ? (
									listData.map((row, index) => (
										<div
											key={index}
											className="mobile-product-card"
											style={{
												borderBottom: '1px solid #eee',
												padding: '10px 20px',
												background: index % 2 === 0 ? '#fff' : '#f9f9f9',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
												gap: 12,
												width: '100%'
											}}
										>
											<div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 4 }}>
												<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
													<div style={{ fontWeight: 600, fontSize: 16, marginBottom: 2 }}>{row?.name}</div>
													<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
														<Dropdown className="btnDel iconbtn">
															<Dropdown.Toggle as="span" id={`dropdown-toggle-mobile-${index}`}>
																<i className="fas fa-ellipsis-h "></i>
															</Dropdown.Toggle>
															<Dropdown.Menu>
																<Dropdown.Item
																	onClick={() => {
																		history(`/settings/productcategories/${row?.id}`);
																	}}
																>
																	Edit
																</Dropdown.Item>
																<Dropdown.Item onClick={() => handleDelete(row?.id)}>Delete</Dropdown.Item>
															</Dropdown.Menu>
														</Dropdown>
													</div>
												</div>
												<div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
													<div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
														<div>Grades</div>
														{row?.has_grade_variations ? (
															<div className="activeStatus bg-success">Yes</div>
														) : (
															<div className="inactiveStatus bg-danger">No</div>
														)}
													</div>
													<div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
														<div>Storage</div>
														{row?.has_storage_variations ? (
															<div className="activeStatus bg-success">Yes</div>
														) : (
															<div className="inactiveStatus bg-danger">No</div>
														)}
													</div>
													<div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
														<div>Colors</div>
														{row?.has_color_variations ? (
															<div className="activeStatus bg-success">Yes</div>
														) : (
															<div className="inactiveStatus bg-danger">No</div>
														)}
													</div>
													<div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
														<div>Skip Operation</div>
														{row?.has_skip_inbounding ||
														row?.has_skip_quality_control ||
														row?.has_skip_repairing ||
														row?.has_skip_retesting ||
														row?.has_skip_testing ? (
															<div className="activeStatus bg-success">Yes</div>
														) : (
															<div className="inactiveStatus bg-danger">No</div>
														)}
													</div>
												</div>
											</div>
										</div>
									))
								) : (
									<div style={{ textAlign: 'center', color: '#888', padding: 24 }}>
										<div className="not-found-icon" style={{ fontSize: 32, marginBottom: 8 }}>
											<TbDatabaseExclamation />
										</div>
										<div style={{ fontSize: 15 }}>No Data Available</div>
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
			<Modal show={show} onHide={handleClose} centered>
				<Modal.Body>
					<Modal.Title>Confirm Delete</Modal.Title>
					<p>Are you sure you want to delete {`${show.name}`}</p>
					<Button variant="primary" className="m-2 " onClick={handleClose}>
						Cancel
					</Button>
					<Button
						variant="danger"
						className="m-2"
						onClick={() => {
							handleDelete(show.id);
						}}
					>
						Delete
					</Button>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default ProductCategories;
